import { FancyRadio } from 'apps/builder/components/settings/modal'
import { selectStyles } from 'apps/builder/components/shared'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import Select from 'react-select'
import {
  RequiredToggle,
  ReadOnlyToggle,
  SettingsFieldSelect,
} from 'apps/builder/components/settings/modal/shared'
export const DateField = ({
  guid,
  label,
  required,
  read_only,
  default: defaultValue,
  style,
  type,
  keyField,
}) => {
  const dispatch = useDispatch()

  const onSaveFormat = style => {
    const format = {
      0: 'm/d/Y',
      1: 'd/m/Y',
      2: 'Y/m/d',
    }
    return format[style] || format[0]
  }
  const dateFormat = onSaveFormat(style)
  const dateOptions = [
    { label: 'Current Date', value: 'null' },
    { label: 'No Default (Blank)', value: 'BLANK' },
  ]
  let assignDefault = value => (value == 'null' ? null : value)
  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
          style={style}
        />
        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle guid={guid} active={required} />
          </div>
          <div className="toggle-wrapper">
            <ReadOnlyToggle guid={guid} active={read_only} />
          </div>
        </div>
      </div>

      <div className="settings--format--wrapper">
        <label className="settings--label">Style</label>
        <FancyRadio
          id={`${guid}-1`}
          label={'MM/DD/YYYY'}
          selected={dateFormat}
          value={'m/d/Y'}
          onChange={checked => {
            checked
              ? dispatch(
                  updateEntry({
                    guid: guid,
                    style: 0,
                  })
                )
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-2`}
          label={'DD/MM/YYYY'}
          selected={dateFormat}
          value={'d/m/Y'}
          onChange={checked => {
            checked
              ? dispatch(
                  updateEntry({
                    guid: guid,
                    style: 1,
                  })
                )
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-3`}
          label={'YYYY/MM/DD'}
          selected={dateFormat}
          value={'Y/m/d'}
          onChange={checked => {
            checked
              ? dispatch(
                  updateEntry({
                    guid: guid,
                    style: 2,
                  })
                )
              : ''
          }}
        />
      </div>
      <div className="settings--default-value">
        <Select
          styles={selectStyles}
          className="input--placeholder"
          classNamePrefix="react-select"
          options={dateOptions}
          value={dateOptions.find(({ value }) => value == `${defaultValue}`)}
          onChange={({ value }) => {
            dispatch(
              updateEntry({
                guid,
                default: assignDefault(value),
              })
            )
          }}
        />
        <label className="label-default-value">Default Value</label>
      </div>
    </>
  )
}
